import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { FormattedMessage } from "react-intl";
import { PanelCard } from "cxa-components";
import { PaperClipIcon } from "cxa-icons";
import MentalHealthIcon from "assets/images/icon/icon-mental-health.svg";
import { FormattedCustomDate } from "components/common/FormattedComponents";
import messagesDescription from "components/messagesDescription";

const Status = ({ status }) => {
  return status === "New" ? status : "";
};

/**
 * MessageCard component
 * @extends PureComponent
 */
class MessageCard extends PureComponent {
  static propTypes = {
    isSelected: PropTypes.bool,
    onClick: PropTypes.func,
    to: PropTypes.string,
    from: PropTypes.string,
    createOn: PropTypes.string,
    status: PropTypes.string,
    subject: PropTypes.string,
    pkMessage: PropTypes.string,
    hasAttachment: PropTypes.bool,
  };

  render() {
    const {
      isSelected,
      onClick,
      from,
      to,
      status,
      subject,
      hasAttachment,
      createOn,
      pkMessage,
    } = this.props;

    const { inAppMessages } = messagesDescription;
    const { fromText, subjectText, toText } = inAppMessages;
    const handleClick = onClick({ pkMessage });
    const cls = cx("message", "message--selectable", {
      "message--active": isSelected,
    });
    // const summary = [
    //   `From: ${from}\n`,
    //   `Subject: ${subject}\n`
    //   `To: ${to}`
    // ].join('');

    return (
      <li className="in-app-message">
        <PanelCard>
          <button type="button" className={cls} onClick={handleClick}>
            <div className="message-status">
              <Status status={status} />
            </div>

            <div className="message-row flex-row">
              <div className="row icon">
                <MentalHealthIcon />
              </div>

              <div className="row meta flex-col flex-space-around">
                <div className="meta-date">
                  <strong className="flex-row flex-space-between">
                    <FormattedCustomDate value={createOn} />
                    <FormattedCustomDate value={createOn} customFormat="H:mm A" />

                    {hasAttachment && (
                      <span>
                        <PaperClipIcon />
                      </span>
                    )}
                  </strong>
                </div>

                <div className="meta-hb flex-col">
                  <div className="text-wrap">
                    <strong>
                      <FormattedMessage {...fromText} />
                    </strong>{" "}
                    {from}
                  </div>

                  <div className="text-wrap">
                    <strong>
                      <FormattedMessage {...subjectText} />
                    </strong>{" "}
                    {subject}
                  </div>

                  <div className="text-wrap">
                    <strong>
                      <FormattedMessage {...toText} />
                    </strong>{" "}
                    {to}
                  </div>
                </div>
              </div>
            </div>
          </button>
        </PanelCard>
      </li>
    );
  }
}

export default MessageCard;



// WEBPACK FOOTER //
// ./components/inAppMessages/MessageCard.js